/** Motion timing tokens — see docs/DESIGN_SYSTEM.md */
export const easing = [0.16, 1, 0.3, 1] as const;

export const durations = {
  micro: 0.12,
  base: 0.24,
  page: 0.32,
} as const;

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
